var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBillReduction = function SvgBillReduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bill-reduction_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.912 84.347C-26.03-5.065 125.934-30.541 119.82 60.227c-2.782 41.436-48.902 22.765-75.352 34.56-14.578 6.518-34.891 6.468-40.555-10.44Z",
    fill: "#EAEAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.43 60.915h11.416c1.046 0 1.9.854 1.9 1.901v34.252c0 1.047-.854 1.9-1.9 1.9H12.43c-1.047 0-1.9-.853-1.9-1.9V62.816c0-1.047.853-1.9 1.9-1.9Z",
    fill: "#F4997D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.43 60.915h5.708v38.06H12.43c-1.047 0-1.9-.855-1.9-1.902V62.822c0-1.047.853-1.901 1.9-1.901v-.006Z",
    fill: "#E87F56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.46 40.079h11.415c1.047 0 1.9.854 1.9 1.9v55.089c0 1.047-.853 1.9-1.9 1.9H31.459c-1.046 0-1.9-.853-1.9-1.9V41.98c0-1.047.854-1.901 1.9-1.901Z",
    fill: "#F4997D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.46 40.079h5.707v58.895H31.46c-1.046 0-1.9-.854-1.9-1.9V41.984c0-1.047.854-1.9 1.9-1.9v-.006Z",
    fill: "#E87F56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.483 43.577h11.415c1.047 0 1.901.854 1.901 1.901v51.59c0 1.047-.854 1.9-1.9 1.9H50.482c-1.047 0-1.901-.853-1.901-1.9v-51.59c0-1.047.854-1.9 1.9-1.9Z",
    fill: "#FFD553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.483 43.577h5.708v55.397h-5.708c-1.047 0-1.901-.854-1.901-1.9v-51.59c0-1.047.854-1.901 1.9-1.901v-.006Z",
    fill: "#EFB920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.942 22.862h-.33v74.212c0 1.046.853 1.9 1.9 1.9h11.415c1.047 0 1.901-.854 1.901-1.9V40.557c-7.707-2.732-13.487-9.465-14.892-17.696h.006ZM86.64 41.533v55.513c0 1.047.854 1.9 1.901 1.9h11.416c1.046 0 1.9-.853 1.9-1.9V38.773a22.663 22.663 0 0 1-11.415 3.091c-1.306.022-2.568-.121-3.807-.33h.005Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.942 22.862h-.33v74.212c0 1.046.853 1.9 1.9 1.9h5.708V36.013c-3.758-3.377-6.397-7.967-7.278-13.15ZM90.442 41.886c-1.306 0-2.568-.143-3.807-.33v55.512c0 1.047.854 1.9 1.9 1.9h5.708V41.55c-1.234.215-2.495.33-3.807.33l.006.006Z",
    fill: "#014A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.442 38.084c-10.512 0-19.03-8.517-19.03-19.029S79.93.025 90.442.025c10.511 0 19.029 8.518 19.029 19.03s-8.518 19.03-19.03 19.03Z",
    fill: "#FFD553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.22 19.055c0-9.873 7.514-17.983 17.122-18.936a16.638 16.638 0 0 0-1.9-.093c-10.512 0-19.03 8.517-19.03 19.03 0 10.511 8.518 19.028 19.03 19.028.644 0 1.283-.022 1.9-.093-9.608-.975-17.123-9.085-17.123-18.936Z",
    fill: "#EFB920"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#014A99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.004 11.693a.948.948 0 0 0 0 1.355l7.206 7.206a.59.59 0 0 0 .81 0l3.4-3.399 6.947 6.947 1.355-1.355-7.873-7.873c-.215-.215-.573-.215-.81 0l-3.4 3.4-6.28-6.281c-.358-.358-.975-.358-1.355 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.794 26.364 6.518-6.517c.215-.215.545-.05.545.237V26.6c0 .193-.143.33-.33.33h-6.518c-.259-.021-.402-.38-.215-.572v.005Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bill-reduction_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .026)",
    d: "M0 0h120v98.949H0z"
  })))));
};
export default SvgBillReduction;